<template>
  <div class="legalagreement_bigbox">
      <div class="legalagreement_title"></div>
      <div class="legalagreement_box">
          <div class="legalagreement_content tab-head">
              <ul>
                  <li @click="optionItem(1)"><span :style="{opacity:(listItem=='1'?'1':'0')}"></span><a href="javascript:;" :class="[listItem=='1' ? 'check_font':'no_check_font']" >版权家平台免责声明</a></li>
                  <li @click="optionItem(2)"><span :style="{opacity:(listItem=='2'?'1':'0')}"></span><a href="javascript:;" :class="[listItem=='2' ? 'check_font':'no_check_font']">版权家平台用户注册协议</a></li>
                  <li @click="optionItem(3)"><span :style="{opacity:(listItem=='3'?'1':'0')}"></span><a href="javascript:;" :class="[listItem=='3' ? 'check_font':'no_check_font']">隐私政策</a></li>
                  <li @click="optionItem(4)"><span :style="{opacity:(listItem=='4'?'1':'0')}"></span><a href="javascript:;" :class="[listItem=='4' ? 'check_font':'no_check_font']">版权家平台互联网版权授权交易风险提示书</a></li>
                  <li @click="optionItem(5)"><span :style="{opacity:(listItem=='5'?'1':'0')}"></span><a href="javascript:;" :class="[listItem=='5' ? 'check_font':'no_check_font']">自动续费协议</a></li>
              </ul>
          </div>
          <div class="tab-content">
              <div :style="{display:(listItem=='1'?'block':'none')}">
                  <h2>版权家平台免责声明</h2>
                  <p>尊敬的版权家平台使用者：</p>
                  <p>您在使用版权家平台时，需要注意以下免责事项：</p>
                  <p>版权家平台用户进行版权交易存在的风险可能导致平台用户的经济损失，平台用户应自行承担。其风险包括但不限于：</p>
                  <p>1、您通过版权家平台参与版权家平台提供的服务之前，应当根据《版权家平台用户注册协议》的规定，进行用户注册并完成实名认证。</p>
                  <p>因您未按版权家平台相关规定进行用户注册及实名认证，而在版权家平台参加版权家平台提供的服务时，造成的一切现有的或未来可能发生的风险或损失，与版权家平台无涉，由您自行承担。如因您提供的资料不准确、不真实或未及时变更有关信息或资料所导致的法律后果和损失，包括对版权家或任何第三方的损害赔偿责任，将由您自行承担。</p>
                  <p>2、版权家平台并不参与任何版权授权交易，因此您通过版权家平台授权他人使用的作品可能被其他交易参与人或第三人提起版权权属争议或其他投诉；您通过版权家平台获得授权使用的作品亦可能被其他交易参与人或第三人提起侵权投诉。一切因通过版权家平台进行版权授权交易的作品的权属争议而产生的责任和损失，与版权家平台无涉，由您自行承担。</p>
                  <p>3、因不可抗力因素，包括但不限于地震、台风、水灾、火灾、战争、瘟疫、社会动乱等因素可能带来的风险与损失，与版权家平台无涉，由您自行承担。</p>
                  <p>4、您在版权家平台参与版权交易服务时，可能面临的包括但不限于交易价格风险、市场风险、作品差异风险及版权家平台软硬件故障等风险，均可能给您带来风险及损失，您应当充分阅读版权家平台发布的《版权家平台互联网版权授权交易风险提示书》，并确认，上述风险及由此造成的损失，概与版权家平台无涉，由您自行承担。</p>
                  <p>5、版权家平台虽已尽最大义务降低版权交易过程中的权利瑕疵风险，但并非政府或司法机关，无权对用户作品是否侵权作出终局性、实质性审查。</p>
                  <p>6、其他在版权家平台规则中约定的免责事项。</p>
              </div>
              <div :style="{display:(listItem=='2'?'block':'none')}">
                  <h2 style="margin-bottom:10px">版权家平台用户注册协议</h2>
                  <p style="margin-bottom:63px">最近更新日期：2026年3月5日</p>
                  <p>欢迎使用版权家平台！</p>
<!--  去掉      <p>【审慎阅读】</p>
                <p>请您务必审慎阅读、充分理解协议中相关条款内容，其中包括：</p>

                <p>1、与您约定免除或限制责任的条款；</p>
                <p>2、与您约定法律适用和管辖的条款；</p>
                <p>3、其他以粗体下划线标识的重要条款。</p>

                <p>如您对协议有任何疑问，可向平台客服咨询。</p>-->

                <p>【特别提示】</p>

                <p>当您按照注册页面提示填写信息、阅读并同意协议且完成全部注册程序后，即表示您已充分阅读、理解并接受协议的全部内容。如您使用版权家平台服务，要遵循《中华人民共和国网络安全法》、《中华人民共和国著作权法》、《信息网络传播权保护条例(2006)》、《著作权集体管理条例(2004)》、《中华人民共和国著作权法实施条例》、《实施国际著作权条约的规定(1992)》、《世界知识产权组织版权条约(1996)》、《区块链信息服务管理规定》、《版权家平台用户注册协议》及版权家平台其他相关协议。如您在使用版权家平台服务过程中与其他用户或其它任意第三方发生争议的, 将依照您与其他用户或其它任意第三方达成的协议处理。</p>

                <p>阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止注册程序。</p>

                <p>第一条 总则</p>

                <p>1、版权家平台，是由北京版全家科技发展有限公司（以下简称“北京版全家”）负责运营，专业提供包括但不限于版权登记服务、版权存证服务、版权交易服务、版权监测服务、版权维权服务、版权价值评估服务、版权增值服务及国际版权服务等版权服务，具体服务内容由版权家平台根据实际情况提供。</p>

                <p>2、版权家平台用户注册协议（以下简称“本协议”），是您与北京版全家就版权家平台的注册和使用订立的在线协议。</p>

                <p>3、版权家平台用户是指自愿接受本协议及版权家全部规则约束，依照平台相关程序经过注册成为平台的使用者，从而有资格享受平台所提供相关服务的自然人、法人或其他组织等。</p>

                <p>4、本协议可由版权家平台根据需要进行更新，您应当及时关注并同意。版权家平台的通知、公告、声明、规则、管理办法或其他规则内容属于本协议的组成部分，平台进行公示后即视为您已阅读并接受，对您发生法律效力。如您不接受对本协议的修改，请立即注销已经注册的信息，版权家平台将即时停止对您的服务。</p>

                <p>第二条 定义</p>

                <p>1、版权家会员分为试用会员和VIP会员。您可根据需求选择开通会员的类别、时间和服务期间。版权家平台的会员服务为收费的网络服务。对于收费的网络服务，版权家平台会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用该等收费网络服务。如用户拒绝支付相关费用，则版权家平台有权不向用户提供该等收费网络服务。特别提示：会员均可设置为自动续费，如果您不需要，可随时取消。</p>

                <p>2、本协议所称加油包，指版权家平台为满足您在指定服务中频繁使用某一单项服务所推出的针对单项服务增加使用次数的会员包。</p>

                <p>3、本协议所称版权登记服务，指由权利人申请，通过版权家平台，与国家版权局或地方版权局对接实现的在线方式的版权登记服务，申请人通过在线方式将需要登记作品相关的著作权人身份信息、版权相关信息、版权证明文件及作品样本等按照在线数字版权登记的标准要求提交给版权局，通过审核后核准登记，并下发电子版作品登记证书。</p>

                <p>4、本协议所称版权存证服务，指由权利人申请，通过版权家平台，将权利人提供的作品信息，经授时服务器由版权区块链联盟进行记录存证，并对权利人的版权交易服务进行存证的服务。</p>

                <p>5、电子数据保管函，是由公证处出具的函证，指由权利人委托版权家平台以版权家名义向公证处发起，将权利人上传的本地作品的样本或网络作品的原网址传送给公证处。由公证处对作品的样本或原发网页截图、MD5值等做电子数据保管存证。</p>

                <p>6、本协议所称版权交易服务，指版权家平台提供的，使用人购买权利人作品版权的中介和平台服务，包括交易撮合、款项代收代付、交易见证存证。</p>

                <p>7、本协议所称版权监测服务，指版权家平台提供的对于指定的作品或者作品集合在互联网网络上的发布、阅读、播放、转载、素材使用等情况的信息收集和统计分析服务。版权家提供的监测报告只代表提供监测结果时监测到的情况，此报告不具备任何法律效力。</p>

                <p>8、本协议所称版权取证服务，指版权家平台提供的通过网页截屏、视频录屏等多种方式固化证据，并将此数据上传至版权区块链的服务。您只是通过版权家平台进行了取证，版权家平台对该证据是是否为法院所采信不承担保证责任。</p>

                <p>9、本协议所称版权维权服务，指版权家平台同第三方律师事务所、公证处、仲裁局、反侵权联盟、内容平台等合作或者委托，为权利人提供打击和制止版权侵权、索回损失、法律诉讼等服务。</p>

                <p>10、本协议所称版权价值评估服务，指由版权家平台提供的，对作品的版权价值进行评估的服务。</p>

                <p>11、本协议所称国际版权服务，指引入国外作品版权、国内作品版权出海、国外作品国内维权、国内作品海外维权等服务。</p>

                <p>第三条 账号注册及管理</p>

                <p>1、用户资格</p>
                <p>您注册版权家平台账号时，应具备中华人民共和国法律规定的与该注册行为相适应的民事行为能力。若您不具备前述与行为相适应的民事行为能力，则您或您的监护人应依照法律规定承担因此而导致的一切法律后果。</p>

                <p>2、账户获得</p>
                <p>当您按照注册页面提示正确、完整的填写信息、阅读并同意本协议且完成全部注册程序后，本协议即生效，您可获得版权家平台的账户并成为版权家平台用户。您成为版权家平台用户后，即受本协议的约束，当您在使用版权家平台的特殊服务和产品时，仍应同意和接受相关服务协议后方能使用。</p>

                <p>3、账号优惠服务说明</p>
                <p> (1)如您已开通成为试用会员，当您的体验服务次数使用完毕后，将无法再行购买加油包，您只能选择暂停服务、或升级为VIP会员。</p>
                <p> (2)如您选择升级为VIP会员，将需按照提示选择支付相应的费用，付费成功后即成为VIP会员，在此基础上您可以享受加油包服务；</p>
                <p> (3)如您已开通了VIP会员，试用会员期间所剩余的体验次数将自动清零；</p>
                <p> (4)如您的会员过期，已购买的加油包则自动清零。</p>

                <p>4、账户转让</p>
                <p>由于用户账户关联用户的信用信息，仅当由法律明文规定、司法裁定或经版权家平台书面同意，并符合版权家平台规则规定的账户转让流程的情况下，您方可进行账户的转让。否则，您的账户不得以任何方式转让，您的账户名下所进行的任何行为均视为您进行的交易行为，由此产生的一切责任均由您自己承担。</p>

                <p>5、实名认证</p>
                <p>法律并未赋予版权家平台强制要求用户进行实名认证的权利，但为使您更好地体验版权家平台的各项服务，版权家平台建议您按照版权家平台的要求及我国法律规定完成实名认证。您因未进行实名认证而造成的一切法律责任及后果，由您自行承担，与版权家平台无涉。</p>

                <p>6、账户管理</p>
                <p>您设置的用户名不得违反国家法律法规关于用户的管理规定，否则版权家平台有权收回或禁用您的账户。若您的账户因违反相关规定遭版权家平台禁用，您可以申请更改用户名，经版权家平台审核后恢复使用。</p>

                <p>7、账户信息</p>
                <p>您应按版权家平台的要求填写注册信息、提交资料或其他身份信息（包括但不限于您的姓名/企业名称、身份证/营业执照、联系电话、联系地址及电子邮件等），并应确保所填写的信息或资料真实、完整、准确、有效，如有变化，应及时在个人中心-账户信息中查看并更改相关信息或资料，无法更改部分请联系客服申请更改。如因您提供的资料不准确、不真实或未及时变更有关信息或资料所导致的法律后果和损失，包括对版权家或任何第三方的相关法律责任，将由您自行承担。</p>

                <p>8、账户安全</p>
                <p>您的账户由您自行设置并妥善保管，因黑客行为或您保管疏忽导致帐号、密码遭他人非法使用或因您主动泄露或遭受他人攻击、诈骗等行为导致的损失及后果，均由您自行承担。如您发现帐号遭他人非法使用，应立即通知版权家平台。如因您未及时通知版权家平台，您应对您账户项下所有行为结果（包括但不限于在线签署各类协议、发布信息、著作权授权、著作权购买等）负责，后期如因此给您或第三方造成损失的，均由您自行承担。</p>

                <p>第四条 如何共享、转让、公开披露您的用户信息</p>

                <p>1、共享</p>
                <p>我们不会与其他组织和个人共享您的用户信息，但以下情况除外：</p>

                <p> (1)在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息；</p>
                <p> (2)在法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；</p>
                <p> (3)为了促成交易或协助解决争议，某些情况下只有共享您的用户信息，才能促成交易或处理您与他人的纠纷或争议，例如，在版权家平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，版权家有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成；</p>
                <p> (4)与授权合作伙伴共享：我们可能委托受信赖的合作伙伴来提供服务，因此我们可能会与合作伙伴共享您的某些用户信息，以提供更好的客户服务和优化用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息。我们的合作伙伴无权将共享的用户信息用于任何其他用途。</p>

                <p>目前，我们的授权合作伙伴包括如下类型：供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供基础技术服务、提供咨询、分析等专业服务。</p>

                <p>对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、隐私政策以及其他任何相关的保密和安全措施来处理用户信息。</p>

                <p>授权合作伙伴收集和处理信息等行为遵守其自身的隐私权政策，但我们也会努力审查该合作伙伴的业务准入资质并努力要求其合法合规性和安全性，并共同实施完善的机制来保护您的个人信息安全，以免遭受未经授权的访问、使用或披露。</p>

                <p> “版权家”平台服务含有到其他网站的链接。除法律另有规定外，“版权家”平台对其他网站的隐私保护措施不负任何责任。我们可能在任何需要的时候增加商业伙伴或共用品牌的网站，但是提供给他们的将仅是综合信息，我们将不会公开您的身份。</p>

                <p>2、转让</p>

                <p>我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：</p>

                <p> (1)在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息；</p>
                <p> (2)或为保护版权家平台及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或版权家平台相关协议、规则披露关于您的用户信息。</p>

                <p>3、公开披露</p>

                <p>我们仅会在以下情况下，公开披露您的用户信息：</p>

                <p> (1)获得您明确同意或基于您的主动选择，我们可能会公开披露您的用户信息；</p>
                <p> (2)或为保护版权家平台及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或版权家平台相关协议、规则披露关于您的用户信息。</p>

                <p>4、共享、转让、公开披露用户信息时事先征得授权同意的例外</p>

                <p>以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意：</p>

                <p> (1)与国家安全、国防安全有关的；</p>
                <p> (2)与公共安全、公共卫生、重大公共利益有关的；</p>
                <p> (3)与犯罪侦查、起诉、审判和判决执行等有关的；</p>
                <p> (4)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
                <p> (5)您自行向社会公众公开的个人信息；</p>
                <p> (6)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

                <p>根据法律规定，共享经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>

                <p>第五条 用户承诺与保证</p>

                <p>1、 您自愿申请成为版权家平台用户并遵守版权家平台的各项规则和机制。</p>

                <p>2、 您使用版权家平台各项服务的，应遵守版权家平台的各项服务规范，包括但不限于《版权家平台用户注册协议》等。</p>

                <p>3、 您确认已充分、完全、准确地认识和理解《版权家平台互联网版权授权交易风险提示书》（以下简称“风险提示书”）所述各项风险，并自愿承担上述风险可能导致的损失。</p>

                <p>4、 您确认已阅读并自愿遵守我国的法律法规、各项部门规章制度及版权家平台相关规则，并接受北京版全家关于版权家平台相关业务规则的修订，修订内容以在版权家平台官方网站发布公告等形式通知您。</p>

                <p>5、您保证对提供的内容负全部责任，不得在版权家平台上传或交易含有下列内容之一的作品，否则版权家平台有权自行处理并不予以通知：</p>
                <p> (1)违反宪法确定的基本原则的；</p>
                <p> (2)危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的；</p>
                <p> (3)损害国家荣誉和利益的；</p>
                <p> (4)煽动民族仇恨、民族歧视，破坏民族团结的；</p>
                <p> (5)破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
                <p> (6)散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
                <p> (7)散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
                <p> (8)侮辱或者诽谤他人，侵害他人合法权益的；</p>
                <p> (9)煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>
                <p> (10)以非法民间组织名义活动的；</p>
                <p> (11)含有法律、行政法规禁止的其他内容的。</p>

                <p>6、 您应保证对通过版权家平台进行版权授权、许可的一切作品均享有完整的知识产权，或者已经得到相关权利人的合法授权（包括但不限于职务作品、委托作品或合作作品），并向版权家平台提供真实合法有效的授权文本、证明等。因违反本条规定而造成第三方争议、索赔、赔偿、诉讼的，由您自行承担责任，与版权家平台无涉。因违反本条规定而造成第三方向交易平台索赔的，您应补偿版权家平台因此承担的一切损失（包括但不限于损失赔偿、诉讼费、律师代理费以及其他相关合理支出）。</p>

                <p>7、 用户有权随时可向版权家平台申请将上传的作品删除，版权家平台也可自行判断决定删除任何违反法律、法规、本协议规定及版权家平台相关规则的作品。当第三方认为您进行著作权授权、许可的作品可能构成侵权时，并根据《信息网络传播权保护条例》或者相关法律规定向本站发送权利通知书时，您同意并授权版权家平台可以自行判断并决定删除涉嫌侵权作品，除非您提交了具有充分证明效力的书面证据材料足以排除侵权的可能性，否则版权家平台不负有恢复上述删除内容的义务。</p>

                <p>8、 您确保在版权家平台使用网络服务时不得违反以下规定，否则版权家平台有权要求您改正或直接采取一切必要有效措施（包括但不限于删除上传并提供授权的作品、信息，暂停或终止使用网络服务的权利）以减轻您的不当行为所造成的影响：</p>

                <p> (1)遵守中国现行有关的法律、法规；</p>
                <p> (2)遵守所有与网络服务有关的网络协议、规定和程序；</p>
                <p> (3)不得提供虚假信息或资料；</p>
                <p> (4)不得因任何非法目的而使用版权家平台的网络服务系统；</p>
                <p> (5)不得利用版权家平台进行任何可能对互联网的正常运转造成不利影响的行为；</p>
                <p> (6)不得利用版权家平台进行任何不利于交易平台的行为；</p>
                <p> (7)不得利用版权家平台进行任何存在严重损害版权家平台、中国版权区块链联盟正常经营秩序、影响市场正常交易秩序的行为；</p>

                <p>9、 您确保将按照我国法律法规及版权家平台规则行使通过版权家平台获得的一切权利，因您不当使用而造成的一切后果，由您自行承担。</p>

                <p>10、您保证在版权家平台参与版权交易及其他付费服务的资金来源合法，否则由此引起的一切法律后果和责任均由您自行承担。</p>

                <p>11、您应确保用于付费的设备的安全性和可靠性。因您的设备故障、通讯故障等原因造成的法律后果和经济损失，均由您自行承担。</p>

                <p>12、您同意并授权版权家平台按照交易信息为您办理交易账户与其他交易账户之间的交易价款划转，代为办理涉税事宜等，同意按照版权家平台的相关规定交纳包括但不限于交易手续费、保管费、其他服务费用等。</p>

                <p>13、您同意并授权版权家平台及关联服务提供方或二者任何一方委托的第三方通过合法渠道（包括但不限于征信机构等）了解、咨询、审查用户的个人市场交易风险的真实情况，并据此判断用户的风险状况。</p>

                <p>14、您同意并授权版权家平台将您作品的全部或部分在版权家平台和版权区块链联盟平台上进行展示。该项授权仅为版权家平台促进您的作品交易和维权之目的，不视为版权家平台参与了版权交易。</p>

                <p>15、您承诺将妥善保管交易账号、交易密码及相关密保文件，若因泄密而造成的损失，您将自行承担相应责任。</p>

                <p>16、您同意并授权版权家平台全权代理您的版权业务（包括但不限于版权登记、合同备案、证书撤销等）。</p>

                <p>第六条 版权家平台承诺及保证</p>

                <p>1、 版权家平台承诺其严格遵守国家法律法规、各项部门规章制度的规定，并愿意接受本协议所有条款的约束。</p>

                <p>2、 版权家平台确保其已采取合理有效的技术措施保护您的账户信息、资料、交易活动的安全。尽管如此，本着对您负责的态度，版权家平台在此郑重提醒您，《风险提示书》所述各项风险客观上仍然存在。</p>

                <p>3、 版权家平台承诺对您的账户信息、资料、交易活动负有保密义务，但下列情况除外：</p>

                <p> (1)事先获得您的明确授权；</p>
                <p> (2)根据中华人民共和国法律或行政法规、规章的要求；</p>
                <p> (3)根据中华人民共和国国家安全机构、公安部门或其他权力机构的要求，或根据相应的法律程序的要求；</p>
                <p> (4)在紧急情况下为维护用户、其它社会个体或公众的安全及秩序的需要，出于维护社会公共利益的目的；</p>
                <p> (5)为维护版权家平台的合法权益。</p>

                <p>4、 为提升版权家平台的服务质量，版权家可能会与第三方合作为您提供相关的服务，此类合作可能需要包括但不限于版权家平台用户数据与第三方用户数据的互通，在此情况下，您知晓并同意如该第三方同意承担与版权家同等的保护您隐私的责任，则版权家有权将您的账户信息、资料、版权家活动等提供给该第三方，并与该第三方约定数据仅为双方合作的版权家平台服务之目的使用；并且，版权家对该等第三方使用数据的行为进行监督和管理，尽一切合理努力保护您信息的安全性。尽管对您的账户等信息保护做了极大的努力，但是仍然不能保证现有的安全技术措施可以使您的技术信息等免受任何形式的损失。</p>

                <p>第七条 免责条款</p>

                <p>1、 您确认已充分、完全、准确地认识和理解《风险提示书》所述各项风险及其他可能发生的风险，并自愿承担上述风险而导致的损失，版权家平台不承担责任。</p>

                <p>2、 鉴于版权家平台仅为用户提供互联网版权服务和公示的开放平台，并不参与用户之间的实际交易，平台上所累积或交易的文档、图片、视频、音频等内容文件，均来自用户，版权家平台不编辑或修改上传的文档、图片、视频、音频等内容文件。如因授权交易和版权公示行为，导致您与一名或多名其他用户发生争议，或与其他权利人发生争议，您应就上述争议产生或可能产生的索赔、要求或损害等进行全额赔偿并承担相关法律责任，版权家平台对此不承担任何责任。</p>

                <p>3、 版权家平台所有链接网站皆为独立营运网站，版权家不能保证您所浏览的链接网站均为安全、合法、有效。您与各用户之间的互动与交易行为，与版权家平台无涉，版权家平台就因此产生的一切后果免除责任。</p>

                <p>4、 版权家服务可在任何时候为任何原因变更本服务或删除其部分功能。版权家服务可在任何时候取消或终止对用户的服务。版权家服务取消或终止服务的决定不需要理由或通知用户。一旦服务取消，用户使用本服务的权利立即终止。 一旦本服务取消或终止，用户在本服务中储存的任何信息可能无法恢复。</p>

                <p>5、 鉴于互联网服务的特殊性，您确认并同意版权家有权根据业务发展情况随时变更、中断或终止部分或全部的互联网服务，而无需通知也无需承担任何责任。</p>

                <p>6、 版权家需要定期或不定期地对提供的版权家平台或相关设备进行检修或者维护，如因此类情况造成服务在合理时间内的中断，版权家无需为此承担任何责任，但版权家将尽可能事先进行通告。</p>

                <p>7、 对于因不可抗力或版权家不能控制的原因造成的版权家平台服务中断或其他缺陷，版权家不承担任何责任，但将尽力减少因此给您造成的损失和影响。</p>

                <p>8、版权家服务可在任何时候为任何原因变更本服务或删除其部分功能。版权家服务可在任何时候取消或终止对您的服务。版权家服务取消或终止服务的决定不需要理由或通知您。一旦服务取消，您使用本服务的权利立即终止。 一旦本服务取消或终止，您在本服务中储存的任何信息可能无法恢复。</p>

                <p>9、 本协议其他条款中涉及的免除责任的情形。</p>

                <p>第八条 维权委托授权</p>

                <p>1、 版权维权服务，是版权家平台提供给注册用户以保护其著作权合法权益的一系列法律服务。</p>

                <p>2、 当版权家通过平台现有的技术手段监测到对您作品的侵权行为，版权家将率先将监测到的侵权情况告知您。您有权在得知侵权事件后选择是否委托平台启动线上维权服务。若您选择不启动版权家平台提供的线上维权服务，则版权家平台此前为您的作品提供的版权存证和可以作为您自行维权时证明权属的佐证；若您选择授权委托版权家平台对侵害您著作权及与著作权相关权利的行为进行维权，则视为同意版权家平台的委托维权相关规则，并接受版权家平台就您作品的侵权行为进行的各种线上维权行为及其结果（包括但不限于在版权家平台见证下与侵权人签订和解协议，使侵权人以付费使用方式合法使用作品等）。</p>

                <p>3、 版权家提供的线上维权服务，包括但不限于代为发送侵权通知、代为处理侵权链接、代为保存证据、代为签订和解协议等维权处理方式。版权家平台有权在上述授权范围内自行判断采取何种维权方式，有权将该委托授权转委托于律师或其他有资质的第三方进行。</p>

                <p>第九条 协议的变更</p>

                <p>1、 版权家平台可根据国家法律法规变化及维护交易秩序等需要，修改本协议、补充协议，变更后的协议、补充协议（以下简称“变更事项”）将通过法定程序并以本协议第九条约定的方式通知您，修改内容自通知行为发生之日起即生效，代替原有协议部分，您应当同意并确认，或随时关注并阅读最新协议或公告。</p>

                <p>2、 如您不同意已生效的变更协议、事项的，您应当立即停止使用版权家平台依据变更后协议、事项提供的版权家平台服务；如您继续使用版权家平台服务，则视为您同意变更后的协议及事项内容。</p>

                <p>第十条 协议的终止</p>

                <p>1、 版权家平台有权根据情况自行考虑来决定终止对您的账号或服务之使用，终止理由包括但不限于长时间未使用、违反法律法规、违反本协议及版权家平台的其他规则等。</p>
                <p>2、 终止服务后，版权家平台有权将您在版权家平台内的任何内容加以移除并删除。版权家平台对于终止您的账号及相关信息和文件被关闭或删除均不承担任何责任。</p>

                <p>第十一条 通知</p>

                <p>您同意版权家平台以以下合理的方式发送的通知，均视为成功送达通知：</p>
                <p>1、公示的文案；</p>
                <p>2、网站及客户端推送的消息；</p>
                <p>3、根据您预留于版权家平台的联系方式发出的电子邮件、短信、函件等。</p>

                <p>第十二条 法律适用、管辖与其他</p>

                <p>1、 本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。</p>
                <p>2、 用户因使用版权家平台服务所产生及与版权家平台服务有关的争议，由您与版权家平台协商解决。协商不成时，任何一方均应提请北京仲裁委员会依据该会届时有效的仲裁规则进行仲裁。仲裁裁决是终局的，对争议双方具有约束力。仲裁裁决确定有过错的一方应承担其他方追究其过错而支出的仲裁费、公证费、律师费和其他合理费用。仲裁过程中，除各方有争议正在进行仲裁的部分外，本协议应继续履行。</p>
                <p>3、 本协议所称其他版权增值服务，指版权家平台通过拓展作品应用的行业、领域等，帮助用户增加作品版权价值的服务。</p>

              </div>
              <div :style="{display:(listItem=='3'?'block':'none')}">
                  <h2 style="margin-bottom:10px">隐私政策</h2>
                  <p style="margin-bottom:63px">最近更新日期：2026年3月5日</p>
                <p>您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按照法律法规要求，采取相应按照保护措施，尽力保护您的个人信息安全可控。鉴于此，“版权家”平台产品和服务提供者（或者简称“我们”）制定了本《隐私政策》（下称“本政策”）并提醒您：</p>
                <p>本政策适用于“版权家”平台产品及服务，包括“版权家”网页版、APP、客户端。</p>
                <p>在使用“版权家”平台产品或服务前，请您务必仔细阅读并透彻理解本政策全部内容，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用“版权家”平台或服务，即表示您已充分理解并同意本政策。</p>
                <p>如您对本政策内容有任何疑问、意见或建议，请通过文末的联系方式与我们联系。</p>
                <p>特别提示：本政策不适用于其他第三方通过前述网页、APP或客户端向您提供的服务。您向第三方提供的信息不适用本政策，我们建议您查看第三方的信息保护声明，以了解他们如何处理您的信息。对于您使用第三方服务时，向其提供或与他人分享个人信息而产生的后果由您自行承担。</p>

                <p>第一部分 定义</p>

                <p> “版权家”平台服务：指“版权家”（域名为www.bqj.cn）网站及其移动通讯设备客户端（App）；</p>

                <p> “版权家”平台服务提供者：指研发并提供“版权家”平台产品和服务的北京版全家科技发展有限公司；</p>

                <p>个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>

                <p>个人敏感信息：指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息等的个人信息（我们将在本《隐私政策》中对涉及个人敏感信息的有关条款进行显著标识）。</p>

                <p>个人信息删除：指在实际日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</p>

                <p>第二部分、法律声明</p>

                <p>1、权利归属</p>

                <p> “版权家”平台的LOGO、文字及其组合为“版权家”平台专有标识。未经我们书面授权，任何人不得以任何方式展示、使用或做其他处理（包括但不限于复制、传播、展示、镜像、上传、下载），也不得向他人表明您有权展示、使用或做其他处理。</p>

                <p> “版权家”平台所有的产品、服务、技术与所有应用程序或其组件/功能（以下或简称“技术服务”）的知识产权均归属于“版权家”平台所有或归其权利人所有。除非另行声明，“版权家”平台拥有在网站内发布文档等信息（包括但不限于文字、图形、图片、照片、音频、视频、图标、色彩、版面设计、电子文档）的所有权利（包括但不限于版权、商标权、专利权、商业秘密和其他所有相关权利）。未经我们许可，任何人不得擅自使用如上内容（包括但不限于通过程序或设备监视、复制、转播、展示、镜像、上传、下载“版权家”平台网站内的任何内容）。被授权浏览、复制、打印和传播属于“版权家”平台产品和服务信息内容的，该等内容不得用于商业目的且必须注明引用来源，并声明权利归属为我们。</p>

                <p>2、责任限制</p>
                <p> “版权家”平台用户在“版权家”平台移动客户端、官方主页以及开放平台上自行上传、提供、发布相关信息，包括但不限于个人信息、用户名称、公司名称、联系人及联络信息，相关图片、资讯等，该等信息均由用户自行提供，“版权家”平台用户须对其提供的任何信息依法承担全部责任。</p>
                <p> “版权家”平台在此提示，您在使用“版权家”平台产品及服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用“版权家”平台产品及服务从事侵犯他人名誉、隐私、知识产权和其他合法权益的活动。尽管有前述提示，“版权家”平台不对您使用“版权家”平台产品及服务的用途和目的承担任何责任。如果您存在违规使用行为，我们有权停止您的账号使用，并依法向有关部门报告。</p>

                <p>3、知识产权保护</p>
                <p>我们尊重知识产权，反对并打击侵犯知识产权的行为。任何组织或个人认为“版权家”平台提供的产品及服务，可能侵犯其合法权益的，可以通过向“版权家”平台提出权利通知，“版权家”平台将在收到知识产权权利人通知后依法尽快处理；</p>

                <p>第三部分 隐私政策</p>

                <p>一、个人信息的收集与使用</p>

                <p>1、我们如何收集您的信息</p>
                <p>我们会出于本政策所述的以下目的，收集和使用您的个人信息：</p>
                <p> (1)帮助您成为“版权家”平台用户</p>
                <p> (2)如果您希望成为“版权家”平台用户，以便我们为您提供服务，您需要提供如姓名、身份证件信息和手机号码等基本信息，并创建“版权家”平台账号和密码。</p>
                <p> (3)如您需要通过使用“版权家”平台以实现版权登记、版权存证、版权交易、版权监测、版权取证等服务功能，您需要提供以下额外资料补全账号信息，以便我们给您提供“版权家”平台功能的产品或服务：您的电子邮箱、联系地址、和银行卡信息等。但如果您不提供这些信息，将会影响到您使用个性化的产品或服务，但不会影响使用“版权家”平台基本功能及浏览“版权家”平台网页信息。</p>
                <p> (4)成为“版权家”平台用户后，您可以对个人信息进行修改。在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求处理您的个人信息。</p>

                <p>2、向您提供产品或服务</p>

                <p> (1)您向我们提供的信息</p>
                <p>在服务使用过程中，您可以对“版权家”平台产品及服务的体验问题反馈，帮助我们更好地了解您使用我们产品或服务的体验和需求，改善我们产品或服务。</p>

                <p> (2)我们在您使用服务过程中收集的信息</p>
                <p>为向您提供更契合您需求的智能硬件或软件、页面展示和搜索结果、了解产品适配性、识别账号异常状态，我们会收集关于您使用产品、服务以及使用方式的信息并将这些信息进行关联，这些信息包括：</p>
                <p>设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、平台名、设备识别号、系统版本、设备制造商、硬件序列号、设备公网IP、IMEI串号、运营商名称、手机号码、移动国家码和移动网络码、浏览器UA、网卡物理地址、操作系统版本及类型、CPU型号和机器名等）设备所在位置相关信息（例如IP地址、GPS/北斗位置信息以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）。
                  日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间、您访问的网页记录、通话状态信息等。</p>
                <p>请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</p>
                <p>当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>

                <p> (3)我们在您使用个性推荐服务过程中收集的信息</p>
                <p>为向您提供更好、更个性化的服务，例如在不同的服务端或设备上提供更个性化但体验一致的服务，更契合您需求的输入推荐、客服接待或信息推送，了解产品适配性，识别账号异常状态，我们会收集您使用服务的相关信息，这些信息包括：设备信息、日志、服务使用信息。</p>
                <p>日志：当您使用我们的网页或客户端时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间以及访问时长、软硬件特征信息、您需求的网页记录及“版权家”平台服务Cookies信息等。</p>
                <p>服务使用信息：我们会记录您在使用“版权家”平台产品及服务时提交或产生的信息、设置信息（例如记住密码、修改密码时间）等。</p>

                <p> (4)帮您提交及管理订单：当您在我们的产品及/或服务中订购增值服务时（如7天试用会员、VIP会员），我们会通过系统为您生成购买该增值服务的订单，同时该订单中会载明您所订购的服务信息、具体订单号、订单创建时间、您支付的金额，我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客服与售后服务及其他我们明确告知的目的。如您需要纸质发票或订购了企业服务，您需至少提供您的收件人姓名、收件地址、收件人联系电话，以便于我们向您寄送发票或企业服务有关文件。</p>

                <p> (5)帮助您完成支付：为完成增值服务订单支付，您需要提供第三方支付平台（支付宝、微信支付）账户并选择付款方式，我们会将您的用户名、对应的第三方支付平台账户名、订单支付相关信息、订单安全相关设备信息及其他反洗钱法律要求的必要信息通过在应用程序中嵌入的SDK等方式与第三方支付平台共享，前述第三方支付平台将获得您连接网络的权限、手机信息权限，并获取网络状态和wifi状态。</p>

                <p> (6)响应您的客服需求：当您与我们联系或提出争议纠纷处理申请时，为了保障您的账号及系统安全，我们需要核验您的用户身份。为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的通信/通话记录及相关内容（包括账号信息、订单信息、您为了证明相关事实所提供的其他信息，或您留下的联系方式信息），如果您针对具体订单进行咨询、投诉的，我们会留存您的账号信息和订单信息。</p>

                <p> (7)为您提供问答、评论等服务：您可通过我们为您提供的问答、评论及其他信息发布功能公开发布信息（包括文字、图片等形式）。请注意，您在接受前述服务时发布的信息中可能会涉及您或他人的个人信息甚至个人敏感信息，请您在发布此类信息前审慎地考虑是否公开分享相关信息。如您发布的信息中涉及儿童个人信息的，您应当在发布前征得对应儿童监护人的同意。</p>

                <p> (8)第三方向我们提供的信息</p>
                <p>  “版权家”平台将对其他用户进行与您相关的操作时收集关于您的信息，亦可能从“版权家”平台合作第三方或通过其他合法途径获取的您的个人数据信息。</p>

                <p>3、为您提供安全保障</p>
                <p>为预防、发现、调查欺诈、侵权、危害安全、非法或违反与我们的政策或规则的行为，我们可能收集或整合您的用户信息、服务使用信息、设备信息、日志信息以及我们合作伙伴取得您授权或依据法律共享的信息。</p>

                <p>4、其他用途</p>
                <p>我们将基于本政策未载明的其他特定目的收集您的信息时，会事先征求您的同意。</p>
                <p> “版权家”平台收集及使用上述信息的目的是为了更好地经营“版权家”平台产品和服务（包括但不限于向您提供个性化的服务），并且会通过包括但不限于通过网站通知、电子邮件、电话或短信息等方式通知。</p>
                <p>如果我们停止运营“版权家”平台产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公开声明的形式通知您，并根据适用法律的要求处理您的个人信息。</p>

                <p>二、我们如何使用您的信息</p>

                <p>收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，我们会把您的信息用于下列用途：</p>

                <p>1、向您提供您使用的“版权家”平台产品或服务，并维护、改进、优化这些服务及服务体验；</p>

                <p>2、为预防、发现、调查欺诈、侵权、危害安全、非法或违反与我们的政策或规则的行为，保护您、其他用户或公众，我们的合法权益，我们可能使用或整合您的用户信息、服务使用信息、设备信息、日志信息以及我们合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施；</p>

                <p>3、经您许可的其他用途。</p>

                <p>征得授权同意的例外：依照法律、法规及监管政策的规定，在下述情况下，我们可以在不征得您授权同意的情况下，收集、使用您的个人信息：</p>

                <p> (1)与“版权家”平台服务提供者履行法律、法规规定的义务相关的；</p>
                <p> (2)与国家安全、国防安全直接相关的；</p>
                <p> (3)与公共安全、公共卫生、重大公共利益直接相关的；</p>
                <p> (4)与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
                <p> (5)出于维护用户或其他个人的生命、财产等重大合法权益但又难得到本人授权同意的；</p>
                <p> (6)所涉及的个人信息是对应的用户自行向社会公众公开的；</p>
                <p> (7)根据您的要求签订的合同（或其他书面文件），为履行该合同（或该书面文件）所必须的；</p>
                  <p> (8)用于维护所提供的“版权家”平台服务的安全稳定运行所必需的，例如发现、处置“版权家”平台服务的故障；</p>
                  <p> (9)为合法的新闻报道所必需的；</p>
                  <p> (10)学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
                  <p> (11)法律、法规或监管政策规定的其他情形。</p>

                  <p>4、转让。在未获得您事先的明确同意前，我们不会将您的个人信息转让给任何第三方。任何用户如从事上述活动，一经发现，我们将立即终止与该用户的服务协议并追究其法律责任。</p>

                  <p>5、 共享。我们不会与服务提供者之外的任何第三方共享您的个人信息，但以下情况除外：</p>

                  <p> (1)在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息；</p>
                  <p> (2)法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；</p>
                  <p> (3)为了促成交易或协助解决争议，某些情况下只有共享您的用户信息，才能促成交易或处理您与他人的纠纷或争议，例如，在版权家平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，版权家有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成；</p>
                  <p> (4)与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由我们和授权合作伙伴共同提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。</p>

                  <p>目前，我们的授权合作伙伴包括如下类型：供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供基础技术服务、提供咨询、分析等专业服务。</p>

                  <p>对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、隐私政策以及其他任何相关的保密和安全措施来处理用户信息。</p>

                  <p>授权合作伙伴收集和处理信息等行为遵守其自身的隐私权政策，但我们也会努力审查该合作伙伴的业务准入资质并努力要求其合法合规性和安全性，并共同实施完善的机制来保护您的个人信息安全，以免遭受未经授权的访问、使用或披露。</p>

                  <p> “版权家”平台服务含有到其他网站的链接。除法律另有规定外，“版权家”平台对其他网站的隐私保护措施不负任何责任。我们可能在任何需要的时候增加商业伙伴或共用品牌的网站，但是提供给他们的将仅是综合信息，我们将不会公开您的身份。</p>

                  <p>您点击同意本隐私政策时，即视为您授权同意我们的合作伙伴按照前述规定获取并处理您的权限及信息。</p>

                  <p>6、信我们仅会在以下情况下，公开披露您的个人信息：</p>

                  <p> (1)在获得您的明确同意后，我们可能会公开您的个人信息；</p>
                  <p> (2)在法律、法律程序、诉讼或监管部门要求的情况下，我们可能会公开披露您的个人信息。</p>

                  <p>7、共享、公开披露个人信息时事先征得授权同意的例外</p>

                  <p>以下情形中，共享、公开披露您的个人信息无需事先征得您的授权同意：</p>
                  <p> (1)与国家安全、国防安全有关的；</p>
                  <p> (2)与公共安全、公共卫生、重大公共利益有关的；</p>
                  <p> (3)与犯罪侦查、起诉、审判和判决执行等有关的；</p>
                  <p> (4)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
                  <p> (5)您自行向社会公众公开的个人信息；</p>
                  <p> (6)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

                  <p>根据法律规定，共享经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>

                  <p>三、Cookie及同类技术的使用</p>

                  <p>为使您获得更轻松的访问体验，您使用“版权家”平台产品或服务时，我们可能会通过采用各种技术收集和存储您访问“版权家”平台服务的相关数据，在您访问或再次访问“版权家”平台服务时,我们能识别您的身份，并通过分析数据为您提供更好更多的服务。包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入账户信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie、Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。请您理解，我们的某些服务只能通过使用Cookie才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝“版权家”平台的Cookie，但拒绝“版权家”平台的Cookie在某些情况下您可能无法使用依赖于Cookies的“版权家”平台服务的部分功能。</p>

                  <p>网页上常会包含一些电子图像，称为“单像素 GIF 文件”或“网络 beacon”，它可以帮助网站计算浏览网页的用户或访问某些Cookie。我们会通过网络beacon收集您浏览网页活动信息，例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定等。</p>

                  <p>四、我们如何存储与保护您的个人信息</p>

                  <p>我们会将收集到的您的个人信息保存在我们的服务器上，并且仅在中华人民共和国境内储存。我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律对于储存期限有额外的明确要求，同时，我们采取了符合行业标准的安全保护措施，保护您的个人信息，防止其遭到未经授权的访问、公开披露、使用、修改、损坏和丢失。我们会采取一切合理可行的措施，保护您的个人信息。包括但不限于：</p>

                  <p> (1)我们具有明确的职权划分以及成型的访问控制机制，将有权接触到个人信息的工作人员限制在最小必要的范围之内；</p>
                  <p> (2)我们同时采用了加密技术，提高个人信息的安全性，对于个人敏感信息，我们将一律通过https加密协议传输，您的密码、口令在存储时将被额外加密；</p>
                  <p> (3)我们有符合行业标准的数据安全管理体系，目前，我们的重要信息系统已经通过了网络安全等级保护的三级以上测评。</p>

                  <p>互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，从而导致您的合法权益受损，我们将承担相应的法律责任。</p>

                  <p>在不幸发生个人安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话或推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>

                  <p>五、您的个人信息权利及账号注销</p>

                  <p>依照中华人民共和国的相关法律、法规和监管要求，我们保障您对您自己的个人信息行使以下权利：</p>

                  <p>1、查询您的个人信息。您有权查询您的个人信息，法律、法规及监管政策规定的例外情形除外。在使用版权家网页端时，您可以点击页面右上角您的用户名链接按钮进行查询。在使用版权家App时，您可以进入“我的-编辑-个人资料页”进行查询。</p>

                  <p>2、更正您的个人信息。当您发现我们处理的关于您的个人信息有误时，您可以登陆版权家App“我的-编辑-个人资料页”页面随时更正，或前往网页端页面右上角，点击您的用户名链接按钮并在跳转页面修改；请进入版权家App“我的”页面进行修改，或前往网页端页面，并在右上角您的用户名悬停菜单中选择相应栏目进行修改；无法自行修改的信息，您可依照本《隐私政策》所载明的联系方式，向我们提出更正申请。</p>

                  <p>3、删除您的个人信息。以下情形中，您可以自行进入版权家App“我的-编辑-个人资料页”删除您的部分信息，或前往网页端页面右上角，点击您的用户名链接按钮并在弹出页面删除。对于无法删除的信息，您可依照本《隐私政策》所载明的联系方式向我们提出删除个人信息的申请：</p>

                  <p>1) 如果我们处理个人信息的行为违反法律法规；</p>
                  <p>2) 如果我们收集、使用您的个人信息，却未征得您的同意；</p>
                  <p>3) 如果我们处理个人信息的行为违反了与您的约定；</p>
                  <p>4) 如果您不再使用我们的产品或服务，或您按照本《隐私政策》载明的方式注销了您的账号；</p>
                  <p>5) 如果我们不再为您提供产品或服务。</p>

                  <p>4、改变您授权同意的范围。每个业务功能需要相应的个人信息才能得以完成。对于为实现版权家平台服务附加功能相关个人信息的收集和使用，您可以随时给予或收回您的授权同意。您可以与版权家平台服务客服联系，或改变您的移动设备设置给予或收回您的授权同意。当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>

                  <p>5、注销您的账号。您可以通过以下方式申请注销您的账号：</p>

                  <p>您可以向版权家客服邮箱发送电子邮件，提交您注销账号的需求，我们会协助您申请注销您的账号。</p>

                  <p>在您主动注销账号之后，我们将停止为您提供服务，并在法律要求时删除您的个人信息，或使其匿名化处理。</p>

                  <p>在您主动注销账号之后，鉴于“版权家”平台运用了区块链技术，区块链技术的可不篡改的属性，您的个人信息不可删除。</p>

                  <p>六、我们如何处理儿童的个人信息</p>

                  <p>我们的网站及服务主要面向成年人，如果没有监护人的明确同意，儿童不应创建自己的个人信息主体账户。</p>

                  <p>对于经监护人同意而收集儿童个人信息的情况，我们只会在受到监管政策允许、监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</p>

                  <p>尽管适用法律对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。</p>

                  <p>如果我们发现自己在未事先获得监护人同意的情况下收集了儿童的个人信息，我们会尽快设法删除相关数据。</p>

                  <p>七、本《隐私政策》如何更新</p>

                  <p>为了给您带来更好的服务体验，我们可能会不时增加新的服务功能或对原有功能进行优化，因此可能会收集、使用新的个人信息或变更使用个人信息的目的或方式，本《隐私政策》也可能会依照最新的监管政策不时变更。在发生前述变更时，我们将更新本《隐私政策》，并以显著的方式使您知悉，并在征得您的明示同意后收集、使用您的个人信息。</p>

                  <p>未经您明确同意，我们不会削减您按照本《隐私政策》所应享有的权利。我们会在专门页面上发布对本《隐私政策》所做的任何变更。对于重大变更，我们还会提供更为显著的通知（如网站公示或向您提供弹窗提示等形式），说明具体变更内容。</p>

                  <p>八、如何联系我们</p>

                  <p>如果您对本平台的隐私保护政策或数据处理有任何疑问、意见或建议， 可以联系平台客服。</p>

              </div>
              <div :style="{display:(listItem=='4'?'block':'none')}">
                  <h2>风险提示书</h2>
                  <p>尊敬的版权家平台用户：</p>
                  <p>版权交易同其他交易一样，风险和收益并存。为了使您充分了解版权交易风险，特提供《版权家平台互联网版权授权交易风险提示书》（以下简称“风险提示书”）。在您选择进入版权家平台参与版权授权交易时，应仔细阅读和理解风险提示书并自愿承担各项风险。</p>
                  <p>版权家平台用户进行版权交易存在的风险可能导致平台用户的经济损失，平台用户应自行承担。其风险包括但不限于：</p>
                  <p>一.交易价格风险</p>
                  <p>基于授权交易作品的交易价格系由授权方根据市场判断而确定，该交易价格会随着授权方的主观意愿随时调整，获授权方获取相同作品权利时，会存在价格不稳定，甚至高于其他获授权方交易价格的风险。</p>
                  <p>二.版权权属风险</p>
                  <p>版权交易具有独特的风险，其中包括版权权属争议风险。因版权权属确定的复杂性，您通过版权家平台授权他人使用的作品可能会被其他交易参与人或第三人提起权属争议或投诉；您通过版权家平台获得授权使用的作品亦可能被其他交易参与人或第三人提起侵权主张或投诉。</p>
                  <p>版权权属等发生变化或争议，并由此可能造成版权授权交易的价格变化和波动。</p>
                  <p>三.政策及市场风险</p>
                  <p>互联网版权授权交易是一个新型的交易领域，相关政策和交易规范要求的变化可能带来各种不确定的交易风险。</p>
                  <p>四.作品差异风险</p>
                  <p>不同的作品具有不同的特点和风险，影响因素包括作者的地位和市场认可程度、作品的形式、作品的篇幅、作品的市场价值、作品的交易方式等因素所带来的差异性，平台用户需详细阅读相关文件。</p>
                  <p>五.软硬件应用风险</p>
                  <p>(一)因授权交易、清算交收及资金转账是通过电子通讯技术和电脑技术实现，在交易系统已采取相关防护措施的情况下仍存在交易网络或数据库被攻击与病毒感染的可能，同时，通讯技术、电脑技术和相关软件本身具有存在缺陷的可能。</p>
                  <p>(二)版权家平台和第三方资金监管账户无法控制和不可预测的系统故障、设备故障、通讯故障、电力故障等可能导致版权家平台交易系统和第三方资金监管机构的结算系统不能正常运行甚至瘫痪，可能使您的资金转账受到影响。</p>
                  <p>(三)因互联网故障等原因可能使交易指令出现中断、中止、延迟等情况，导致交易申报无法成交、无法全部成交或延迟成交。</p>
                  <p>(四)因网络故障，可能出现：</p>
                  <p>1.平台用户设备的操作界面已经显示申报提交，而交易系统主机未接到其申请指令，从而平台用户实际未能实现转让和受让的风险；</p>
                  <p>2.平台用户因设备的操作界面申请显示转让交易未成功而再次发出申请指令，交易系统服务器因此可能收到两次申请指令并按其指令进行交易，由此给平台用户带来重复交易的风险。</p>
                  <p>(五)因平台用户使用的计算机或设备被病毒侵入、黑客攻击等导致的密码泄露、账号泄露或平台用户身份被冒用，导致无法正确下达申请指令、恶意虚假申请或申请失败、延迟、错误等。</p>
                  <p>(六)平台用户设备及软件系统与平台系统不匹配，可能导致无法下达申请指令或申请失败、延迟等。</p>
                  <p>六.不可抗力因素导致的风险</p>
                  <p>诸如地震、台风、火灾、水灾、战争、瘟疫、社会动乱等不可抗力因素可能带来的风险；</p>
                  <p>上述风险可能会导致平台用户版权交易的损失。平台用户应确保已对上述风险有客观理性的认识。</p>
                  <p>七.账号风险</p>
                  <p>平台用户应当保管好自己的账号和密码，提高警惕，谨防他人欺诈、盗用。</p>
                  <p>八.特别提示</p>
                  <p>本《风险提示书》并不能提示从事互联网版权授权交易的全部风险。敬告平台用户，应当根据自身的经济条件、实用价值、现实需要等调整自身的交易行为。</p>
                  <p>在平台用户参与版权授权交易之时，版权家平台郑重提醒平台用户，认真阅读并谨记以下条款：</p>
                  <p>(一)请合理配置个人资产参与交易的比例，不要将个人全部资产投入到版权交易中。</p>
                  <p>(二)请认真阅读交易作品的基本信息，审慎判断自身的交易需求。</p>
                  <p>(三)请认真了解版权授权交易的模式和特点，了解不同作品的差异和特点。</p>
                  <p>(四)请审慎判断，您是否有权于版权家平台上就授权作品的相关权利授权他人行使。</p>
                  <p>(五)请认真了解版权家平台互联网版权授权交易的相关制度，随时关注版权家平台的调整、公告和补充规定。</p>
                  <p>九.其他</p>
                  <p>版权家平台的所有交易资金划转均是通过版权家平台指定的资金账户实现，请不要把版权授权交易的资金支付给任何其他账户，否则由此引发的一切后果将由平台用户自行承担。</p>
              </div>
              <div :style="{display:(listItem=='5'?'block':'none')}">
                  <h2>自动续费协议</h2>
                  <p>尊敬的版权家平台用户：</p>
                  <p>欢迎使用版权家平台会员自动续费服务（以下统称：自动续费服务）。</p>
                  <p>【注意】版权家平台提醒用户，请仔细阅读以下全部内容，若用户不同意本服务协议的任一或全部条款内容，请不要以确认的形式（包括但不限于：勾选、点击）选择“同意接受”或使用自动续费服务。自动续费服务是从属于版权家平台会员服务之下的子服务，因此，当用户确认接受本服务协议或开始使用自动续费服务时，即表示用户与版权家平台已达成协议关系，并自愿接受并遵守版权家平台会员服务及自动续费服务的所有服务协议及相关之子协议、管理规范等。版权家有权随时修改协议，请用户关注，如您不同意修改后的协议，可选择终止版权家平台的服务。</p>
                  <p>如您未满18周岁，请在监护人的陪同下查看并确认服务协议。</p>
                  <p>本服务协议将作为《版权家平台用户协议》的子协议，与《版权家平台用户协议》具有同等且不可分割之法律效力。</p>
                  <p>一、服务条款的确认和接纳</p>
                  <p>1.1自动续费服务涉及到的一切网络服务之所有权以及相关之知识产权均归版权家平台依法所有，受中华人民共和国法律及国际公约的保护。版权家平台所提供的自动续费服务必须按照其发布的公司章程，服务条款和操作规则严格执行。本服务协议项下的条款效力范围及于版权家平台的一切网络服务，用户在完成注册程序并开始使用版权家平台所提供的自动续费服务时，均应当受本服务协议项下的条款约束。</p>
                  <p>1.2当用户使用自动续费服务时，用户的使用行为将被视为其对该单项服务的相关条款以及版权家平台在该单项服务中所发出的各类公告之同意。</p>
                  <p>二、所有权与使用权</p>
                  <p>2.1用户认可并同意：自动续费服务所涉或可能衍生的一切知识产权权利均由版权家平台依法所有，用户不因使用自动续费服务而自动获得前述的任一或全部权利。同时，版权家平台可以在法定或依据《版权家平台用户协议》之规定对本服务协议中的任一或全部条款进行修改，或对自动续费服务进行调整而毋须事前获得用户许可或事后向用户履行告知义务，且不因收回所述之使用而需承担任何的赔偿义务。版权家平台强烈建议用户，定期关注《版权家平台用户协议》及本服务协议的条款，当用户认为版权家平台对所述的《版权家平台用户协议》及本服务协议之任一或全部条款的调整，或版权家平台网站公告内容的调整不可接受时，请及时终使用对版权家平台，特别是本自动续费服务的使用。</p>
                  <p>三、有效期</p>
                  <p>3.1用户确认并同意：除非版权家平台另行指定，否则用户获得的自动续费服务均为长期有效。用户可以在遵循《版权家平台用户协议》及本协议项下指定的方式来获得自动续费服务及其所指向的其它版权家平台服务。</p>
                  <p>四、自动续费服务所支持的支付方式及用户责任</p>
                  <p>4.1版权家平台将会开通包括但不限于：网上银联、电信运营商代收、百度钱包、微信、支付宝等的支付渠道，以便用户在选择使用自动续费服务时选择不同的支付方式执行支付。</p>
                  <p>4.2用户认可并同意：对于用户选择的支付渠道，用户有义务确保定期关注并确保其于该支付方式的账号项下有充足的余额以满足自动续费服务的应用。如因前述瑕疵（包括但不限于：余额不足、余额不足以满足用户选择多个自动续费服务）而致使无法满足阅读自动续费服务的，版权家平台有权在不再作另行通知的前提下，暂停用户通过自动续费服务所接入的版权家平台相关服务。</p>
                  <p>五、自动续费服务的服务形式</p>
                  <p>5.1本服务由会员自主选择是否取消，若会员选择不取消，则视为会员同意版权家平台在到期前1天为您自动扣款，会员有效期自动相应延长。</p>
                  <p>5.2用户可随时在“版权家平台-个人中心”中，按照相关网页提示，自行操作设置终止本协议服务，终止之后，在当前会员服务服务期满后用户将不再收到支付平台向用户发送的通知短信，也不再为用户自动从绑定账户中扣划下期费用。</p>
                  <p>5.3自动续费时扣除的会员费用时长与用户开通该服务后最近购买的会员时长一致。</p>
                  <p>5.4自动续费时优先从绑定账户余额中扣除会员费用，余额不足部分使用绑定银行卡完成扣划。</p>
                  <p>六、服务内容范围</p>
                  <p>6.1用户通过使用自动续费服务，可以定期获得版权家会员服务，包括但不限于：版权司法存证、版权登记、版权监测、司法取证等。</p>
                  <p>除非版权家平台另外通知，否则自动续费成功后上述的版权家平台会员服务的有效期按照最近购买的会员时长自动顺延，且对于所述之版权家平台会员服务，版权家平台拥有最终的修改权、增删权、解释权。</p>
                  <p>七、合法性保证</p>
                  <p>7.1 所有用户认可并保证：不会使用自动续费服务直接或间接地从事以下违反国家法律法规及社会公序良俗之道德保留之行为：</p>
                  <p>1、违反宪法确定的基本原则的；</p>
                  <p>2、危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
                  <p>3、损害国家荣誉和利益的；</p>
                  <p>4、煽动民族仇恨、民族歧视，破坏民族团结的；</p>
                  <p>5、破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
                  <p>6、散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
                  <p>7、散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
                  <p>8、侮辱或者诽谤他人，侵害他人合法权益的；</p>
                  <p>9、煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>
                  <p>10、以非法民间组织名义活动的；</p>
                  <p>11、含有法律、行政法规禁止的其他内容的。</p>
                  <p>7.2 版权家平台有权对用户就使用自动续费服务之行为进行不定期监督，一旦发现用户涉及上述之行为，版权家平台有权收回用户对自动续费服务的使用权而不对用户作出任何的赔偿。而且，版权家平台将依法向国家机关就用户之行为进行举报并保留进一步追究用户行为而导致版权家平台损失之权利。</p>
                  <p>八、商业化禁止</p>
                  <p>8.1 用户认可并同意：在未获得版权家平台正式书面公开许可之前，用户不得就其所获得之自动续费服务用于非版权家平台服务的其它领域，亦不得直接或间接地对自动续费服务进行任何商业化（包括但不限于：转售、贩卖、等价置换等）的行为。一旦发现用户涉及上述之行为，版权家平台有权收回用户对自动续费服务的使用权而不对用户作出任何的赔偿，并保留进一步追究用户行为而导致版权家平台损失之权利。</p>
                  <p>九、退费</p>
                  <p>版权家平台特别提醒用户：当用户选择使用自动续费服务后，通过自动续费服务以用户默认的支付方式所支付的费用，版权家平台将视用户选择认购了版权家平台的相关付费服务。因此，版权家平台将不以任何方式对用户所支付的费用予以退还。</p>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    metaInfo: {
        title: '平台免责声明|版权服务专家|版权家',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
        },{
            name: 'Description',
            content: '平台免责声明,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
        }]
    },
  name: "instrument",
  data() {
    return {
      listItem:"1"
    }
  },
    // 监听,当路由发生变化的时候执行
    watch:{
        $route(to,from){
            this.optionItem(to.params.id)
        }
    },
  methods: {
    optionItem(i='1'){
        this.$router.push('/instrument/'+i)
        this.listItem=i;
        // this.$router.push('/instrument/'+i)
        // this.$router.push({name:'instrument',params: {id:i}})
    }
  },
  created() {
    this.optionItem(this.$route.params.id)
  },
};
</script>

<style lang="less">
ul li{
  list-style: none;
}
.legalagreement_bigbox{
    width: 100%;
    .legalagreement_box{
        width: 1200px;
        margin: 0 auto 100px;
        box-shadow: 0px 2px 50px 0px rgba(136, 141, 151, 0.09);
        border-radius: 12px;
        background: #ffffff;
        padding-bottom: 98px;
        box-sizing: border-box;
    }
    .legalagreement_title{
        width: 1200px;
        margin: 0 auto;
        height: 50px;
        // font-size: 14px;
        // color: rgba(51,51,51,1);
        // line-height: 20px;
    }
    .legalagreement_title a{
        font-size: 14px;
        color: rgba(51,51,51,1);
        line-height: 20px;
    }
    .legalagreement_content{
        width: 1200px;
    }

    .legalagreement_content ul{
        display: flex;
        justify-content: space-between;
        &:before,
        &:after {
          content: '';
          display: block;
        }
    }
    .legalagreement_content ul li{
        /*float: left;*/
        /*margin-right:90px;*/
        height: 60px;
        line-height: 60px;
        margin-bottom: 69px;
    }
    .legalagreement_content ul li a{
        font-size: 16px;
        line-height: 22px;
        font-style: none;
    }
    .no_check_font{
        color: rgba(153,153,153,1);
    }
    .check_font{
        color:#000000;
    }
    .legalagreement_content ul li span{
        width:0;
        height:0;
        border-width: 5px 0 5px 9px;
        border-style:solid;
        border-color:transparent transparent transparent #333;/*透明 透明 透明 灰*/
        position:relative;
        display: inline-block;
        margin-right: 5px;
    }
    .tab-content h2{
        font-size:22px;
        font-weight:600;
        color:rgba(51,51,51,1);
        line-height:30px;
        margin-left: 78px;
        margin-right: 74px;
        margin-bottom: 63px;
    }
    .tab-content p{
        font-size:16px;
        color:rgba(51,51,51,1);
        line-height:22px;
        margin-left: 78px;
        margin-right: 74px;
        margin-bottom: 25px;
    }
    .tab-content p a{
        font-size:16px;
        color:#FFA400;
        line-height:22px;
    }
}
</style>
